import type { JSX } from "react";

import { newReportAction } from "../applicationBarActions";
import { ReportColumnId, REPORT_COLUMN_IDS } from "../columns";
import { ReportsListLayout } from "../layout";

function ReportsAllPage(): JSX.Element {
    return (
        <ReportsListLayout
            pageType="All"
            columnIds={COLUMN_IDS}
            actions={[newReportAction("All")]}
        />
    );
}

const COLUMN_IDS: Array<ReportColumnId> = [
    REPORT_COLUMN_IDS.NAME_FOR_ALL,
    REPORT_COLUMN_IDS.REPORT_TYPE,
    REPORT_COLUMN_IDS.DESCRIPTION,
    REPORT_COLUMN_IDS.PUSH_REPORTS_COUNT,
    REPORT_COLUMN_IDS.ACCESS_RIGHTS,
    REPORT_COLUMN_IDS.ACTION,
];

export { ReportsAllPage };
